import { render, staticRenderFns } from "./LawMatterSubjectForm.vue?vue&type=template&id=47883a1c&"
import script from "./LawMatterSubjectForm.vue?vue&type=script&lang=js&"
export * from "./LawMatterSubjectForm.vue?vue&type=script&lang=js&"
import style0 from "./LawMatterSubjectForm.vue?vue&type=style&index=0&id=47883a1c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports